import { render, staticRenderFns } from "./GoodListItem.vue?vue&type=template&id=de3cd39c&scoped=true&"
import script from "./GoodListItem.vue?vue&type=script&lang=js&"
export * from "./GoodListItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodListItem.vue?vue&type=style&index=0&id=de3cd39c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3cd39c",
  null
  
)

export default component.exports